exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Notifications {\n  bottom: 0;\n  left: 1%;\n  position: fixed;\n  width: 98%;\n  z-index: 7000;\n}\n.Notifications .alert {\n  border: 0;\n  border-radius: 0;\n  margin-bottom: 15px;\n}\n@media (min-width: 776px) {\n  .Notifications {\n    left: 15%;\n    width: 70%;\n  }\n}\n@media (min-width: 992px) {\n  .Notifications {\n    left: 35%;\n    width: 30%;\n  }\n}\n", ""]);

// exports
